import { z } from 'zod';
import { baseMessageSchema, createMessageId } from './_base';

/**
 * In-app notification inbox signal, sibling of `UserProfileMessage` and NOT the
 * SMS `NotificationMessage`. The payload is a "re-read" signal only: it never
 * carries a title or a body.
 */
export enum NotificationInboxMessageType {
  NOTIFICATION_INBOX_UPDATED = 'NOTIFICATION_INBOX_UPDATED',
}

export const notificationInboxUpdatedPayloadSchema = z.object({
  authId: z.string().optional(),
});

export type NotificationInboxUpdatedPayload = z.infer<typeof notificationInboxUpdatedPayloadSchema>;

const notificationInboxUpdatedSchema = baseMessageSchema
  .extend({
    type: z.literal(NotificationInboxMessageType.NOTIFICATION_INBOX_UPDATED),
  })
  .merge(notificationInboxUpdatedPayloadSchema);

export const notificationInboxMessageSchema = z.discriminatedUnion('type', [
  notificationInboxUpdatedSchema,
]);

export type NotificationInboxMessage = z.infer<typeof notificationInboxMessageSchema>;

export function generateNotificationInboxMessage(
  payload: NotificationInboxUpdatedPayload,
): NotificationInboxMessage {
  const base = {
    id: createMessageId(),
    timestamp: Date.now(),
    type: NotificationInboxMessageType.NOTIFICATION_INBOX_UPDATED,
  };
  return notificationInboxUpdatedSchema.parse({ ...base, ...payload });
}
